export const roles = [
    { key: 'admin', name: '管理员', appliable: true },
    { key: 'referee', name: '裁判员', appliable: true },
    { key: 'referee_admin', name: '裁判长', appliable: true },
    { key: 'reception', name: '检录员', appliable: true },
    { key: 'scheduler', name: '编排长', appliable: true },
    { key: 'scheduler_viewer', name: '编排员', appliable: true },
    { key: 'team_leader', name: '领队', appliable: true },
    { key: 'user', name: '用户', appliable: false },
    { key: 'player', name: '选手', appliable: false },
    { key: 'monitor', name: '监控员', appliable: true },
];
